import React from "react";
import Text from "@/components/ui/text";
import { CheckboxGroupItem } from "@/components/ui/checkbox-group";
import { getPartnerContactFullName } from "@/pages/partners/contacts/helpers";
import { PartnerContactData } from "@/pages/partners/contacts/types";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils/utils";
import { includes, isNull } from "lodash";

interface Props {
  partnerContact: PartnerContactData;
  selectedContacts: string[];
  handleSelectedContactChange: (contactId: string, checked: boolean) => void;
  addedContacts: string[] | null | undefined;
  entityName?: string;
}

const PartnerContactCheckbox: React.FC<Props> = ({
  partnerContact,
  selectedContacts,
  handleSelectedContactChange,
  addedContacts,
  entityName
}) => {
  const { t } = useTranslation();
  const isDisabled = includes(addedContacts, partnerContact.id);
  return (
    <CheckboxGroupItem
      id={partnerContact.id}
      label={
        <>
          <div className="flex flex-col">
            <Text className={isDisabled ? "!text-disabled" : ""}>
              {getPartnerContactFullName(partnerContact)}
            </Text>
            {!isNull(partnerContact.jobTitle) && (
              <Text
                variant="bodySecondary"
                className={isDisabled ? "!text-disabled" : ""}
              >
                {partnerContact.jobTitle}
              </Text>
            )}
          </div>
          {isDisabled && (
            <Text variant="bodyTertiary">
              {t("detailedView.peopleTab.involvedInDeal", { entityName })}
            </Text>
          )}
        </>
      }
      checked={includes(selectedContacts, partnerContact.id)}
      onCheckedChange={(checked: boolean) =>
        handleSelectedContactChange(partnerContact.id, checked)
      }
      disabled={isDisabled}
      containerClassName={cn(
        "justify-start",
        isDisabled
          ? ""
          : "pl-[2px] pr-3 py-2 transition-colors duration-200 ease-in-out rounded hover:bg-surface-hover-soft"
      )}
      labelClassName={isDisabled ? "flex w-full justify-between" : ""}
    />
  );
};

export default PartnerContactCheckbox;
